/**
 * BlogListing
 *
 * Handles blog filter (tag select, search input), load-more visibility
 * and AJAX fetching via the blog-search endpoint.
 */

const VISIBLE_COUNT = 6;
const SEARCH_ENDPOINT = '/blog-search/';
const HIDDEN_CLASS = 'd-none';
const ITEM_SELECTOR = '.blog-teaser';

export default class BlogListing {
    constructor(el) {
        this.el = el;
        this.listing = el.querySelector('[data-blog-listing]');
        this.select = el.querySelector('[data-blog-tags]');
        this.input = el.querySelector('[data-blog-search]');
        this.loadBtn = el.querySelector('[data-blog-load-btn]');
        this.actionWrap = this.loadBtn ? this.loadBtn.closest('.blog-listing-action') : null;

        this.originalHTML = this.listing.innerHTML;
        this.debounceTimer = null;

        this.bindEvents();
        this.applyVisibility();

        console.log(this);
    }

    bindEvents() {
        if (this.select) {
            this.select.addEventListener('change', () => this.onFilterChange());
        }

        if (this.input) {
            this.input.addEventListener('input', () => {
                clearTimeout(this.debounceTimer);
                this.debounceTimer = setTimeout(() => this.onFilterChange(), 400);
            });
        }

        if (this.loadBtn) {
            this.loadBtn.addEventListener('click', () => this.showMore());
        }
    }

    onFilterChange() {
        const tag = this.select ? this.select.value.trim() : '';
        const search = this.input ? this.input.value.trim() : '';

        if (!tag && !search) {
            this.listing.innerHTML = this.originalHTML;
            this.applyVisibility();
            return;
        }

        const params = new URLSearchParams();
        if (tag) params.set('tag', tag);
        if (search) params.set('search', search);

        fetch(`${SEARCH_ENDPOINT}?${params}`)
            .then((res) => res.text())
            .then((html) => {
                this.listing.innerHTML = html;
                this.applyVisibility();
            });
    }

    applyVisibility() {
        const items = this.listing.querySelectorAll(ITEM_SELECTOR);

        items.forEach((item, i) => {
            item.classList.toggle(HIDDEN_CLASS, i >= VISIBLE_COUNT);
        });

        this.updateLoadBtn();
    }

    showMore() {
        const hidden = this.listing.querySelectorAll(`${ITEM_SELECTOR}.${HIDDEN_CLASS}`);
        const batch = Array.from(hidden).slice(0, VISIBLE_COUNT);

        batch.forEach((item) => item.classList.remove(HIDDEN_CLASS));

        this.updateLoadBtn();
    }

    updateLoadBtn() {
        if (!this.actionWrap) return;

        const hasHidden = this.listing.querySelectorAll(`${ITEM_SELECTOR}.${HIDDEN_CLASS}`).length > 0;
        this.actionWrap.classList.toggle(HIDDEN_CLASS, !hasHidden);
    }
}
